import React from "react";
import { VerticalSeparator } from "../../../../settingsForms/separators/verticalSeparator/verticalSeparator";
import { NewTagGroupFormType } from "../../types";
import tagGroupsStyles from "../tagGroups.css";
import { GroupNameInputColumn } from "../groupNameInput/groupNameInputColumn";
import { TagsInputColumn } from "../tagsInput/tagsInputColumn";

interface Props {
  form: NewTagGroupFormType;
}

export const NewTagGroupBox = ({ form }: Props) => {
  return (
    <div className={tagGroupsStyles.form}>
      <GroupNameInputColumn field={form.$.name} />
      <VerticalSeparator />
      <TagsInputColumn field={form.$.tagIds} />
    </div>
  );
};
